/*
 * @Author: wuzhimin14 wuzhimin14@jd.com
 * @Date: 2023-11-15 14:26:33
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-07-27 17:44:34
 * @FilePath: /jdi-web-inter/src/components/FourCategorySelect/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 *
 * @BugFix: Fixed mobile Safari bug where cascader selections were cleared when clicking other inputs
 * - Added isInitializedRef to track initialization state and prevent re-initialization on form updates
 * - Removed formRef from useEffect dependencies to prevent unnecessary re-runs
 * - Added guards to cascading useEffect hooks to prevent conflicts during initialization
 * - Memoized addressData to stabilize prop references
 * - Solution is browser-agnostic and works across all platforms (desktop/mobile, Safari/Chrome/Firefox)
 */
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Col, Form, Row, Select } from 'antd';
import styles from './index.module.scss';
import { getAddressItemList } from '@/api/newApi/personalCenter/address';
import { useSelector } from 'react-redux';
import { PostalCodeAddress } from '@/util/postalCodeAddress';
const { Item } = Form;
const VIETNAM_COUNTRY_CODE = 'VN';

interface ProvinceCityCascaderIndexProps {
  detailData: any;
  disabled?: boolean; //是否禁选
  formRef?: any;
  initialValue?: any;
  required?: boolean;
  param?: any; //额外参数
  handleChange?: (level: string, levelId: string) => void;
  postalCodeAddress?: PostalCodeAddress | null;
}

const ProvinceCityCascaderIndex: React.FC<ProvinceCityCascaderIndexProps> = (props: any) => {
  const { initialValue = {}, detailData, formRef, postalCodeAddress } = props;
  const [countryList, setCountryList] = useState<any[]>([]);
  const [provinceList, setProvinceList] = useState<any[]>([]);
  const [cityList, setCityList] = useState<any[]>([]);
  const [countyList, setCountyList] = useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<any>(detailData.countryId || '');
  const [selectedProvince, setSelectedProvince] = useState<any>(detailData.provinceId || '');
  const [selectedCity, setSelectedCity] = useState<any>(detailData.cityId || '');
  const [selectedCounty, setSelectedCounty] = useState<any>(detailData.countyId || '');
  const [selectedCountryCode, setSelectedCountryCode] = useState<any>(
    detailData?.address?.countryCode || detailData?.address?.country || '',
  );

  // 获取用户信息
  const currentUser: any = useSelector((state: any) => {
    return state?.User?.data?.[0] ?? {};
  });

  // Track whether initial data load is complete to prevent re-initialization on form updates
  // This fixes the mobile Safari bug where cascader values get cleared when clicking other inputs
  const isInitializedRef = useRef(false);

  //
  /**
   * 获取级联地址列表
   * param parentId 上层选中id type 国省市区
   */
  const getAllList = async (parentId: number, type?: string) => {
    const res: any = await getAddressItemList({ parentId });
    if (res.success) {
      const newData = res?.value?.map((item: any) => {
        return {
          value: item.id,
          label: item.name,
          code: item.code, // 保存国家二字码
          name: item.name, // 保存国家名称
        };
      });
      if (type == '1') {
        setProvinceList(newData);
      } else if (type == '2') {
        setCityList(newData);
      } else if (type == '3') {
        setCountyList(newData);
      } else {
        setCountryList(newData);
      }
      return newData;
    } else {
      // Clear corresponding lists if the API call fails or returns no data
      if (type == '1') {
        setProvinceList([]);
      } else if (type == '2') {
        setCityList([]);
      } else if (type == '3') {
        setCountyList([]);
      } else {
        setCountryList([]);
      }
      return [];
    }
  };

  // Memoize address data to prevent unnecessary re-initialization
  const addressData = useMemo(() => detailData?.address, [
    detailData?.address?.countryId,
    detailData?.address?.country,
    detailData?.address?.countryCode,
    detailData?.address?.provinceId,
    detailData?.address?.cityId,
    detailData?.address?.countyId,
    detailData?.address?.countryName,
    detailData?.address?.provinceName,
    detailData?.address?.cityName,
    detailData?.address?.countyName,
  ]);

  // Create a stable identifier for the address to detect when editing different addresses
  // 如果是新增模式（没有countryId），使用visible状态来触发初始化
  const addressId = useMemo(() => {
    if (addressData?.countryId) {
      // 编辑模式：使用ID
      return addressData?.contractId || addressData?.addressId || addressData?.addressManagerId;
    }
    // 新增模式：返回一个固定值，确保每次打开都能初始化
    return 'new';
  }, [addressData?.contractId, addressData?.addressId, addressData?.addressManagerId, addressData?.countryId]);

  // 越南地址后端不要求区县，countyId 仅在其它国家保持必填。
  const isVietnamCountry = String(selectedCountryCode || '').toUpperCase() === VIETNAM_COUNTRY_CODE;

  useEffect(() => {
    if (!isVietnamCountry) return;
    // 越南地址隐藏区县字段时，需要同步清空旧值，避免编辑历史地址时继续提交 countyId。
    setSelectedCounty('');
    setCountyList([]);
    formRef?.setFieldsValue({ countyId: null });
    formRef?.setFields([{ name: 'countyId', errors: [] }]);
  }, [isVietnamCountry]);

  useEffect(() => {
    const initializeAddressData = async () => {
      // 预加载国家列表，避免用户点击时卡顿
      const countryData = await getAllList(-1, '0');
      if (countryData && countryData.length > 0) {
        setCountryList(countryData);
      }

      // 判断是否有有效的地址数据（有countryId才认为是编辑模式）
      const hasValidAddressData = addressData && addressData.countryId;

      if (hasValidAddressData) {
        // 编辑模式：使用已有数据
        const { countryId, provinceId, cityId, countyId, provinceName, cityName, countyName, countryCode, country } =
          addressData;
        const formValuesToSet: any = {
          countryId: null,
          provinceId: null,
          cityId: null,
          countyId: null,
          countryArea: null,
        };
        let resolvedCountryCode = countryCode || country || '';

        setSelectedCountry(countryId);
        formValuesToSet.countryId = countryId;
        formValuesToSet.countryArea = countryId;

        // 尝试从列表中查找该国家的 code (二字码)
        // 如果 addressData 中本身就没有 countryCode，这里通过 ID 反查可以补全
        if (countryData && countryData.length > 0) {
          const foundCountry = countryData.find((c: any) => c.value === countryId);
          resolvedCountryCode = foundCountry?.code || resolvedCountryCode;
          setSelectedCountryCode(resolvedCountryCode);
          if (resolvedCountryCode) {
            formValuesToSet.countryCode = resolvedCountryCode;
            formValuesToSet.country = resolvedCountryCode; // 同时设置 country 字段，确保兼容性
          }
        } else {
          setSelectedCountryCode(resolvedCountryCode);
        }
        const isResolvedVietnamCountry = String(resolvedCountryCode || '').toUpperCase() === VIETNAM_COUNTRY_CODE;

        if (provinceId) {
          // 如果有名称，直接创建选项
          if (provinceName) {
            setProvinceList([{ value: provinceId, label: provinceName }]);
          }
          setSelectedProvince(provinceId);
          formValuesToSet.provinceId = provinceId;

          if (cityId) {
            // 如果有名称，直接创建选项
            if (cityName) {
              setCityList([{ value: cityId, label: cityName }]);
            }
            setSelectedCity(cityId);
            formValuesToSet.cityId = cityId;

            if (countyId && !isResolvedVietnamCountry) {
              // 如果有名称，直接创建选项
              if (countyName) {
                setCountyList([{ value: countyId, label: countyName }]);
              }
              setSelectedCounty(countyId);
              formValuesToSet.countyId = countyId;
            } else {
              if (isResolvedVietnamCountry) {
                // 越南地址不展示区县，编辑回显时也不保留历史区县值。
                setCountyList([]);
              }
              setSelectedCounty('');
              formValuesToSet.countyId = null;
            }
          } else {
            setSelectedCity('');
            setCountyList([]);
            setSelectedCounty('');
            formValuesToSet.cityId = null;
            formValuesToSet.countyId = null;
          }
        } else {
          setSelectedProvince('');
          setCityList([]);
          setSelectedCity('');
          setCountyList([]);
          setSelectedCounty('');
          formValuesToSet.provinceId = null;
          formValuesToSet.cityId = null;
          formValuesToSet.countyId = null;
        }

        formRef?.setFieldsValue(formValuesToSet);
        // Only validate during initialization, not on every form update
        if (formValuesToSet.countryArea && !isInitializedRef.current) {
          formRef?.validateFields(['countryArea']);
        }

        // Mark initialization as complete
        isInitializedRef.current = true;
      } else {
        // 新增模式：只初始化国家，不自动加载省份、城市、区县
        // 从jdig/account/me接口返回的数据中获取countryCode（和userType在同一个地方）
        const userCountryCode = currentUser?.countryCode;
        let defaultCountryId = null;

        // 如果国家列表已加载，尝试根据用户国家匹配
        if (countryData && countryData.length > 0) {
          if (userCountryCode) {
            // 根据用户国家code匹配
            const matchedCountry = countryData.find((item: any) => item.code === userCountryCode);
            if (matchedCountry) {
              defaultCountryId = matchedCountry.value;
            }
          }

          // 如果没找到匹配的国家，使用第一个选项
          if (!defaultCountryId && countryData.length > 0) {
            defaultCountryId = countryData[0].value;
          }

          // 只设置默认国家，不加载下级选项
          if (defaultCountryId) {
            setSelectedCountry(defaultCountryId);
            const selectedCountryItem = countryData.find((item: any) => item.value === defaultCountryId);
            const countryCode = selectedCountryItem?.code || '';
            setSelectedCountryCode(countryCode);

            // 只设置国家，不加载省份、城市、区县
            formRef?.setFieldsValue({
              countryId: defaultCountryId,
              countryArea: defaultCountryId,
              countryCode: countryCode,
              provinceId: null,
              cityId: null,
              countyId: null,
            });
          } else {
            // 没有国家列表，清空所有
            setSelectedCountry('');
            setSelectedCountryCode('');
            setProvinceList([]);
            setSelectedProvince('');
            setCityList([]);
            setSelectedCity('');
            setCountyList([]);
            setSelectedCounty('');
            formRef?.setFieldsValue({
              countryId: null,
              provinceId: null,
              cityId: null,
              countyId: null,
              countryArea: null,
            });
          }
        } else {
          // 国家列表未加载，清空所有
          setSelectedCountry('');
          setSelectedCountryCode('');
          setProvinceList([]);
          setSelectedProvince('');
          setCityList([]);
          setSelectedCity('');
          setCountyList([]);
          setSelectedCounty('');
          formRef?.setFieldsValue({
            countryId: null,
            provinceId: null,
            cityId: null,
            countyId: null,
            countryArea: null,
          });
        }
        isInitializedRef.current = true;
      }
    };

    // Reset initialization flag when address changes (editing different address)
    // This allows re-initialization for new addresses
    isInitializedRef.current = false;
    initializeAddressData();
  }, [addressId]); // Depend on addressId to detect address changes

  useEffect(() => {
    if (!postalCodeAddress) return;

    const nextProvinceId = postalCodeAddress.provinceId || null;
    const nextCityId = postalCodeAddress.cityId || null;
    const nextCountyId = postalCodeAddress.countyId || null;

    // 页面当前一级地址是匹配条件，邮编回填只替换下三级，不能改变客户已选国家。
    if (nextProvinceId && postalCodeAddress.provinceName) {
      setProvinceList([{ value: nextProvinceId, label: postalCodeAddress.provinceName }]);
    } else {
      setProvinceList([]);
    }
    if (nextCityId && postalCodeAddress.cityName) {
      setCityList([{ value: nextCityId, label: postalCodeAddress.cityName }]);
    } else {
      setCityList([]);
    }
    if (nextCountyId && postalCodeAddress.countyName) {
      setCountyList([{ value: nextCountyId, label: postalCodeAddress.countyName }]);
    } else {
      setCountyList([]);
    }

    setSelectedProvince(nextProvinceId || '');
    setSelectedCity(nextCityId || '');
    setSelectedCounty(nextCountyId || '');
    formRef?.setFieldsValue({
      provinceId: nextProvinceId,
      cityId: nextCityId,
      countyId: nextCountyId,
    });
    void formRef
      ?.validateFields(['provinceId', 'cityId', 'countyId'])
      .catch(() => undefined);
    isInitializedRef.current = true;
  }, [
    postalCodeAddress?.provinceId,
    postalCodeAddress?.provinceName,
    postalCodeAddress?.cityId,
    postalCodeAddress?.cityName,
    postalCodeAddress?.countyId,
    postalCodeAddress?.countyName,
  ]);

  // These useEffects handle user interaction AFTER initial load
  // Guards prevent conflicts with initialization process
  useEffect(() => {
    // Only fetch provinces when user changes country selection after initialization
    if (isInitializedRef.current && selectedCountry) {
      getAllList(selectedCountry, '1');
    }
  }, [selectedCountry]);

  useEffect(() => {
    // Only fetch cities when user changes province selection after initialization
    if (isInitializedRef.current && selectedProvince) {
      getAllList(selectedProvince, '2');
    }
  }, [selectedProvince]);

  useEffect(() => {
    // Only fetch counties when user changes city selection after initialization
    if (isInitializedRef.current && selectedCity) {
      if (isVietnamCountry) {
        // 越南地址没有可选区县层级，切换城市后仍保持 countyId 为空。
        setSelectedCounty('');
        setCountyList([]);
        formRef?.setFieldsValue({ countyId: null });
        formRef?.setFields([{ name: 'countyId', errors: [] }]);
        return;
      }
      getAllList(selectedCity, '3');
    }
  }, [selectedCity, isVietnamCountry]);

  return (
    <div className={styles.index}>
      <Item
        label={TLT(`请选择地址`)}
        name="countryArea"
        rules={[
          {
            required: true,
            message: TLT(`请选择地址`),
          },
        ]}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Item
              name={'countryId'}
              className={styles.itemStyle}
              rules={[{ required: true, message: TLT(`请选择国家`) }]}
            >
              <Select
                options={countryList}
                placeholder={TLT(`请选择国家`)}
                className={styles.select}
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                onFocus={async () => {
                  // 国家列表在初始化时已经加载，这里只需要处理列表为空的情况（新建模式）
                  if (countryList.length === 0) {
                    const countryData = await getAllList(-1, '0');
                    if (countryData && countryData.length > 0) {
                      setCountryList(countryData);
                    }
                  }
                }}
                onChange={async (value: any, option: any) => {
                  setSelectedCountry(value);
                  setSelectedProvince('');
                  setSelectedCity('');
                  setSelectedCounty('');
                  setCityList([]);
                  setCountyList([]);
                  // 获取选中国家的 code（二字码）
                  const selectedCountryItem = countryList.find((item: any) => item.value === value);
                  const countryCode = selectedCountryItem?.code || option?.code || '';
                  setSelectedCountryCode(countryCode);
                  // 用户选择国家后，加载省份列表
                  const provinceData = await getAllList(value, '1');
                  if (provinceData && provinceData.length > 0) {
                    setProvinceList(provinceData);
                  }
                  // Batch form updates to reduce re-renders
                  formRef?.setFieldsValue({
                    provinceId: null,
                    cityId: null,
                    countyId: null,
                    countryArea: value, // 当国家选择后，countryArea才算有值
                    countryCode: countryCode, // 保存国家二字码
                    country: countryCode, // 同时保存 country 字段
                  });
                  if (countryCode === VIETNAM_COUNTRY_CODE) {
                    formRef?.setFields([{ name: 'countyId', errors: [] }]);
                  }
                  // Validate only after user interaction, not during initialization
                  if (isInitializedRef.current) {
                    formRef?.validateFields(['countryArea']);
                  }
                }}
              />
            </Item>
          </Col>
          <Col span={12}>
            <Item
              name={'provinceId'}
              className={styles.itemStyle}
              rules={[{ required: true, message: TLT(`请选择省份`) }]}
            >
              <Select
                options={provinceList}
                placeholder={TLT(`请选择省份`)}
                className={styles.select}
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                onFocus={async () => {
                  // 用户点击下拉框时，如果列表为空或只有一个选项（可能是从名称创建的），则加载完整列表
                  if (
                    selectedCountry &&
                    (provinceList.length === 0 ||
                      (provinceList.length === 1 && provinceList[0].value === selectedProvince))
                  ) {
                    const provinceData = await getAllList(selectedCountry, '1');
                    if (provinceData && provinceData.length > 0) {
                      setProvinceList(provinceData);
                    }
                  }
                }}
                onChange={async (value: any) => {
                  setSelectedProvince(value);
                  setSelectedCity('');
                  setSelectedCounty('');
                  setCountyList([]);
                  // 用户选择省份后，加载城市列表
                  const cityData = await getAllList(value, '2');
                  if (cityData && cityData.length > 0) {
                    setCityList(cityData);
                  }
                  // Batch form updates to reduce re-renders
                  formRef?.setFieldsValue({
                    cityId: null,
                    countyId: null,
                  });
                }}
              />
            </Item>
          </Col>
          <Col span={12}>
            <Item name={'cityId'} className={styles.itemStyle} rules={[{ required: true, message: TLT(`请选择城市`) }]}>
              <Select
                options={cityList}
                placeholder={TLT(`请选择城市`)}
                className={styles.select}
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                onFocus={async () => {
                  // 用户点击下拉框时，如果列表为空或只有一个选项（可能是从名称创建的），则加载完整列表
                  if (
                    selectedProvince &&
                    (cityList.length === 0 || (cityList.length === 1 && cityList[0].value === selectedCity))
                  ) {
                    const cityData = await getAllList(selectedProvince, '2');
                    if (cityData && cityData.length > 0) {
                      setCityList(cityData);
                    }
                  }
                }}
                onChange={async (value: any) => {
                  setSelectedCity(value);
                  setSelectedCounty('');
                  if (isVietnamCountry) {
                    // 越南地址隐藏区县选择，不再请求区县列表。
                    setCountyList([]);
                    formRef?.setFields([{ name: 'countyId', errors: [] }]);
                  } else {
                    // 用户选择城市后，加载区县列表
                    const countyData = await getAllList(value, '3');
                    if (countyData && countyData.length > 0) {
                      setCountyList(countyData);
                    }
                  }
                  // Update form field
                  formRef?.setFieldsValue({
                    countyId: null,
                  });
                }}
              />
            </Item>
          </Col>
          {!isVietnamCountry && (
            <Col span={12}>
              <Item
                name={'countyId'}
                className={styles.itemStyle}
                rules={[{ required: true, message: TLT(`请选择区`) }]}
              >
                <Select
                  options={countyList}
                  placeholder={TLT(`请选择区`)}
                  className={styles.select}
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  onFocus={async () => {
                    // 当用户点击下拉框时，如果列表为空或只有一个选项（可能是从名称创建的），则加载完整列表
                    if (
                      selectedCity &&
                      (countyList.length === 0 || (countyList.length === 1 && countyList[0].value === selectedCounty))
                    ) {
                      const countyData = await getAllList(selectedCity, '3');
                      if (countyData && countyData.length > 0) {
                        setCountyList(countyData);
                      }
                    }
                  }}
                  onChange={(value: any) => {
                    setSelectedCounty(value); // 更新区/县的选中状态
                    // Update validation field
                    formRef?.setFieldsValue({
                      countryArea: selectedCountry, // 确保在选择区/县后，整体地址校验字段有值
                    });
                    // Validate only after user interaction
                    if (isInitializedRef.current) {
                      formRef?.validateFields(['countryArea']);
                    }
                  }}
                />
              </Item>
            </Col>
          )}
        </Row>
      </Item>
    </div>
  );
};

export default ProvinceCityCascaderIndex;
